import {postMethod} from '~/api'

async function post(request, params) {
    return await postMethod('/api/cancelService', request, {params})
}

export {post}
